<template>
  <div class="lottery_algorithm_bg">
    <div class="lottery_algorithm_title_bg">
      <img
        class="lottery_algorithm_title"
        src="../../assets/lottery/decoration_left.png"
      />
      <p class="lottery_algorithm_title">抽奖算法</p>
      <img
        class="lottery_algorithm_title"
        src="../../assets/lottery/decoration_right.png"
      />
    </div>
    <div
      class="lottery_rule_content_title"
      v-for="(value, index) in algorithm"
      :key="index"
    >
      <div
        v-bind:class="{
          lottery_rule_content_title_bold: index < 2
        }"
      >
        <div v-if="value.lenght != 0">
          <span class="lottery_rule_content_title_span_black">{{
            algorithmBlack[index]
          }}</span>
          <span class="lottery_rule_content_title_span_red">{{
            algorithmRed[index]
          }}</span>
          <span>{{ value }}</span>
        </div>
        <div class="lottery_rule_content_space_bold" v-if="index == 4"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";
import { LotteryRuleContent } from "../../hooks/LotteryRuleContent";

export default class Algorithm extends Vue {
  algorithm: string[] = [];
  algorithmBlack: string[] = [];
  algorithmRed: string[] = [];
  mounted() {
    this.algorithm = LotteryRuleContent.algorithm;
    this.algorithmBlack = LotteryRuleContent.algorithmBlack;
    this.algorithmRed = LotteryRuleContent.algorithmRed;
  }
}
</script>

<style scoped lang="less">
@import "../../style/BaseStyle.less";
.lottery_algorithm_bg {
  margin: 10px 20px 0px 20px;
  width: ~"calc(100%-40px)";
  background-color: white;
  border-radius: 10px;
  padding: 19px 0px 21px 0px;
  height: auto;
  overflow: hidden;
  .lottery_algorithm_title_bg {
    padding: 0px 0px 0px 0px;
    width: 100%;
    display: flex;
    text-align: center;
    margin: 0 auto;
    margin-bottom: 14px;
    justify-content: center;
    .lottery_algorithm_title {
      text-align: center;
      margin: 0 auto;
      margin-left: 3px;
      margin-right: 3px;
      font-size: 16px;
      color: #111111;
      font-weight: bold;
      height: 20px;
    }
  }
  .lottery_rule_content_title {
    margin-left: 20px;
    margin-right: 20px;
    text-align: left;
    font-size: 13px;
    color: #222222;
    padding: 0px;
  }
  .lottery_rule_content_title_bold {
    font-weight: bold;
  }
  .lottery_rule_content_title_span_black {
    color: #222222;
    padding: 0px;
    margin: 0px;
    font-size: 13px;
  }
  .lottery_rule_content_title_span_red {
    color: #f82c2c;
    padding: 0px;
    margin: 0px;
    font-size: 13px;
  }
  .lottery_rule_content_space_bold {
    height: 20px;
  }
}
</style>
